export type MenuItem = {
  id: number;
  name: string;
  description?: string;
  price: number; // আমরা number রাখছি; backend string দিলেও normalize করব
  imageUrl?: string;
  category: number;
  available: boolean;
};

function authHeader() {
  if (typeof window === "undefined") return {};
  const t = localStorage.getItem("accessToken");
  return t ? { Authorization: `Bearer ${t}` } : {};
}

// backend price string হলে number এ কনভার্ট
function normalize(item: any): MenuItem {
  return {
    id: Number(item?.id),
    name: String(item?.name ?? ""),
    description: item?.description ?? "",
    price:
      typeof item?.price === "string"
        ? parseFloat(item.price)
        : Number(item?.price ?? 0),
    imageUrl: item?.imageUrl ?? "",
    category: Number(item?.category ?? 0),
    available: Boolean(item?.available),
  };
}

export async function listMenu(): Promise<MenuItem[]> {
  const res = await fetch("/api/menu", { method: "GET", cache: "no-store" });
  if (!res.ok) throw new Error(`List failed (${res.status})`);
  const data = await res.json();

  return data.menu ? data.menu : [];
}

export async function createMenu(payload: Omit<MenuItem, "id">) {
  console.log(payload);
  const res = await fetch("/api/menu", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    throw new Error((await res.text()) || "Create failed");
  }

  const data = await res.json();

  const raw =
    data?.menu ??
    data?.data?.menu ??
    data?.data ??
    data?.created ??
    data?.result ??
    data;

  return normalize(raw);
}

export async function updateMenu(
  id: number,
  payload: Partial<Omit<MenuItem, "id">>
): Promise<MenuItem> {
  const auth = authHeader();
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  if (auth.Authorization) headers["Authorization"] = auth.Authorization;

  const res = await fetch(`/api/menu/${id}`, {
    method: "PUT",
    headers,
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`Update failed (${res.status})`);
  const data = await res.json();
  const raw = data?.menu ?? data;
  return normalize(raw);
}

export async function deleteMenu(id: number): Promise<void> {
  const auth = authHeader();
  const headers: Record<string, string> = {};
  if (auth.Authorization) headers["Authorization"] = auth.Authorization;

  const res = await fetch(`/api/menu/${id}`, {
    method: "DELETE",
    headers,
  });
  if (!res.ok) throw new Error(`Delete failed (${res.status})`);
}

export async function getMenu(id: number): Promise<MenuItem> {
  const res = await fetch(`/api/menu/${id}`, {
    method: "GET",
    cache: "no-store",
  });
  if (!res.ok) throw new Error(`Get failed (${res.status})`);
  const data = await res.json();
  const raw = data?.menu ?? data;
  return normalize(raw);
}
